import { render, staticRenderFns } from "./Form2Table.vue?vue&type=template&id=1c23adc1"
import script from "./Form2Table.vue?vue&type=script&lang=ts"
export * from "./Form2Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports